import { $t } from "@/utils";
export const INTERNAL_KEY = 0
export const MAIL_KEY = 1
export const TRANSFER_KEY = 2
export const INAPP_KEY = 3
export const ADD_ATTACH_TYPE = 1 // 添加附件类型
export const DEL_ATTACH_TYPE = 0 // 删除附件类型

export const INTERNAL_STORE_NAME = 'internal' // 内部回复
export const MAIL_STORE_NAME = 'mail' // 电子邮件
export const TRANSFER_STORE_NAME = 'transfer' // 流转升级
export const INAPP_STORE_NAME = 'inApp' // 异步消息

export const MIN_EDITOR_HEIGHT = 110 // editor 最小高度
export const MAX_EDITOR_HEIGHT = document.body.offsetHeight > 850 ? 220 : 170 // editor最大高度
export const INIT_EDITOR_HEIGHT = MAX_EDITOR_HEIGHT // editor默认高度

export const REPLY_TYPE = {
    [INTERNAL_KEY]: { label: $t('CS_1_Internal_message_Dmzz'), storeName: INTERNAL_STORE_NAME, type: 'inner', module: 'contentTabMessage' }, // 内部回复
    [MAIL_KEY]: { label:  $t('CS_1_E_mail_rKAg'), storeName: MAIL_STORE_NAME, type: 'reply', module: 'contentTabEmail' },// 电子邮件
    [TRANSFER_KEY]: { label:  $t('chat.transfer'), storeName: TRANSFER_STORE_NAME, type: 'flow' },// 流转升级
    [INAPP_KEY]: { label:  $t('chat.onlineResponse'), storeName: INAPP_STORE_NAME, type: 'reply', module: 'contentTabInApp' }, // 异步消息
}

export const INIT_TYPE = [INTERNAL_KEY, MAIL_KEY] // 回复类型默认展示 
export const UPLOAD_TYPE = [INTERNAL_STORE_NAME, MAIL_STORE_NAME, TRANSFER_STORE_NAME] // 回复类型 上传附件展示 列表 